import { api } from "@/lib/api";

export interface CompanyDocument {
  display_title?: string | null; archive_category?: string; document_type_name?: string | null;
  issued_on?: string | null; expires_on?: string | null; created_at?: string | null; original_filename?: string | null;
  id: string; dokument_id: string; naziv: string; opis: string | null;
  kategorija: string; gradiliste_id: string | null; verified: boolean;
  retention_review_required: boolean;
  deleted_at: string | null;
  deleted_by_id: string | null;
  deleted_by_name: string | null;
}
export async function getCompanyDocuments(params: { search?: string; gradiliste_id?: string; include_deleted?: boolean }, signal?: AbortSignal): Promise<CompanyDocument[]> {
  return (await api.get<CompanyDocument[]>("/company-documents", { params, signal })).data;
}
export async function deleteCompanyDocument(id: string): Promise<CompanyDocument> {
  return (await api.delete<CompanyDocument>(`/company-documents/${id}`)).data;
}
export async function getCompanyDocumentContent(id: string, signal?: AbortSignal): Promise<Blob> {
  return (await api.get<Blob>(`/company-documents/${id}/content`, { responseType: "blob", signal })).data;
}

export async function renameCompanyDocument(id: string, naziv: string): Promise<CompanyDocument> {
  return (await api.patch<CompanyDocument>(`/company-documents/${id}/title`, { naziv })).data;
}
